/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UpdateUserNotificationSetting200ResponseAllOfData } from './UpdateUserNotificationSetting200ResponseAllOfData';
import {
    UpdateUserNotificationSetting200ResponseAllOfDataFromJSON,
    UpdateUserNotificationSetting200ResponseAllOfDataFromJSONTyped,
    UpdateUserNotificationSetting200ResponseAllOfDataToJSON,
} from './UpdateUserNotificationSetting200ResponseAllOfData';

/**
 * 
 * @export
 * @interface UpdateUserNotificationSetting200ResponseAllOf
 */
export interface UpdateUserNotificationSetting200ResponseAllOf {
    /**
     * 
     * @type {UpdateUserNotificationSetting200ResponseAllOfData}
     * @memberof UpdateUserNotificationSetting200ResponseAllOf
     */
    data?: UpdateUserNotificationSetting200ResponseAllOfData;
}

/**
 * Check if a given object implements the UpdateUserNotificationSetting200ResponseAllOf interface.
 */
export function instanceOfUpdateUserNotificationSetting200ResponseAllOf(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateUserNotificationSetting200ResponseAllOfFromJSON(json: any): UpdateUserNotificationSetting200ResponseAllOf {
    return UpdateUserNotificationSetting200ResponseAllOfFromJSONTyped(json, false);
}

export function UpdateUserNotificationSetting200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserNotificationSetting200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : UpdateUserNotificationSetting200ResponseAllOfDataFromJSON(json['data']),
    };
}

export function UpdateUserNotificationSetting200ResponseAllOfToJSON(value?: UpdateUserNotificationSetting200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': UpdateUserNotificationSetting200ResponseAllOfDataToJSON(value.data),
    };
}

